export default {
    product:'Produk',
    BlackList:'Daftar Hitam',
    xinyongbaogao: "Laporan Kredit",
    useCases:"Contoh Kasus",
    News:"Berita",
    Company:"Perusahaan ",
    aboutUs:"Tentang kami",
    contactUs:"Hubungi Kami",
    privacy:"Kebijakan Privasi"
};
